// export const BASE_API_URL = "https://api-dev.portal.idc.md/api/v3/adm";
export const BASE_API_URL = "https://iptvn.idc.md/api/v3/portal/adm";

// номер версии с датой
export const version = "2.0.1 от 26.10.2026";
